<template>
  <section>
    <h2 class="heading">
      <router-link v-if="!isRepo" :to="`/search/?type=${type}`" class="heading__link">
        <span class="heading__label">
          <img v-if="labelIcon" class="heading__label-icon" :class="{ 'heading__label-icon_alone': !label }"
            :src="labelIcon" />
          {{ label }}
        </span>
        <span class="heading__text">{{ heading || $t("APPS") }}</span>
        <img class="heading__icon" :src="require(`@/assets/themes/${BRAND_KEY}/images/icon-chevron.svg`)" />
      </router-link>
      <span v-else class="heading__text">{{ heading }}</span>


    </h2>

    <slot name="new">
      <div v-if="isRepo ? !list.new.length : !list.new.length || !list.top.length" class="apps">
        <div class="app app_stub" v-for="n in 24" :key="n">
          <div class="app__link">
            <app-icon />
            <span class="app__title">t</span>
            <div class="app__category">t</div>
          </div>
        </div>
      </div>
      <div v-else class="apps" v-show="tab === 'new'">
        <div class="app" :class="{ 'app_repo': isRepo }" v-for="(app, index) in list.new" :key="app.id">
          <router-link :to="isRepo ? `/repos/${repoId}/app/${app.idxKey}` : `/app/${type}/${app.id}`" class="app__link">
            <app-icon :src="app.image || app.iconURL" />

            <span class="app__title">{{ app.name }}</span>
            <span v-if="isRepo" class="app__category app__category_wrap">
              {{ app.developerName }}
            </span>
            <router-link v-else class="app__category" :to="`/search/?type=${type}&genre=${app.genre_id}`">
              {{ $t(genres[type][app.genre_id].name.toUpperCase()) }}</router-link>
          </router-link>
        </div>
        <div v-if="list.new.length % 8" class="apps__spacer"></div>
      </div>
    </slot>
  </section>
</template>

<script>
import AppIcon from './AppIcon.vue';

export default {
  props: {
    label: String,
    labelIcon: String,
    heading: String,
    list: Object,
    type: String,
  },
  components: {
    AppIcon,
  },
  data() {
    return {
      tab: 'new',
      iconsFailedToLoad: {},
      loadedIcons: {},
    };
  },
  computed: {
    genres() {
      return this.$store.getters.genres;
    },
    repoId() {
      return this.$route.params.id;
    },
    isRepo() {
      return this.type === 'repo';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.heading {
  display: flex;
  margin-bottom: 20px;

  &__link {
    display: flex;
    align-items: center;
    font-weight: 600;
    max-width: calc(100% - 130px);
    flex-grow: 1;
  }

  &__label {
    display: flex;
    align-items: center;
    padding: 5px;
    background: #3d464d;
    border-radius: 3px;
    color: #fff;
    margin-right: 9px;

    @media (max-width: 600px) {
      flex: 0 1;
    }

    &-icon {
      filter: brightness(0) invert(1);

      &:not(&_alone) {
        margin-right: 3px;
      }
    }
  }

  &__text {
    color: var(--text-primary);
    font-size: 20px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__icon {
    margin: 3px 0 0 5px;
    height: 11px;
  }

  &__nav {
    margin-left: auto;
  }
}

.nav {
  display: flex;
  align-items: center;
  color: var(--text-primary);
  font-size: 16px;
  font-weight: 500;

  &__notebook-hide {
    @include notebook {
      display: none;
    }
  }

  &__item {
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;

    &:not(:first-child) {
      margin-left: 10px;
    }

    &:not(:last-child) {
      margin-right: 10px;

      &:after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        right: -10px;
        width: 1px;
        background-color: #9797977a;
        pointer-events: none;
      }
    }

    &_active {
      &:before {
        content: "";
        display: block;
        position: absolute;
        left: 2px;
        right: -2px;
        bottom: -7px;
        height: 2px;
        background-color: $primary;
      }
    }
  }

  &__icon {
    margin-right: 5px;
    margin-top: 1px;
  }
}

.apps {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: calc(100% + 20px);
  position: relative;
  left: -10px;
  padding-bottom: 2px;

  &__spacer {
    flex: auto;
  }

  @include notebook {
    flex-wrap: nowrap;
    overflow: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      width: 0 !important;
      display: none !important;
    }
  }
}

.app {
  width: 100px;
  padding: 0 10px;
  margin-bottom: 20px;

  &_stub {
    .app {

      &__title,
      &__category {
        background: var(--stub-bg);
        color: transparent;
        border-radius: 6px;
      }
    }
  }

  @include notebook {
    margin-bottom: 0;
  }

  @for $i from 0 through 3 {
    @media (max-width: 767px - ($i * 55px)) {
      &:not(.app_repo):nth-child(n + #{13 - $i}) {
        display: none;
      }

      flex-basis: calc(100% / #{13 - $i});
    }
  }

  @media (max-width: 767px) {
    &:not(.app_repo):nth-child(-n + 16) {
      display: block;
    }
  }

  &__link {
    display: block;
  }

  &__title,
  &__category {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &__title {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: var(--text-primary);
    margin: 6px 0 4px;
    line-height: 16px;
  }

  &__category {
    color: $text-secondary;
    font-weight: 500;
    font-size: 11px;
    text-decoration: underline dotted;
    @include transition;

    &_wrap {
      white-space: normal;
      word-break: break-word;
      overflow: visible;
      line-height: 14px;
    }

    &:is(a):hover {
      color: $dark-primary;
    }
  }
}
</style>
